import { InsightsMetricsSplit } from "@octopusdeploy/octopus-server-client";
import type { InsightsReportResource } from "@octopusdeploy/octopus-server-client";
import type { ReportMetricsPageProps } from "app/areas/insights/components/Reports/ReportMetricsLayout/ReportMetricsLayout";
import { ReportMetricsLayout } from "app/areas/insights/components/Reports/ReportMetricsLayout/ReportMetricsLayout";
import React, { useEffect } from "react";
import { useAnalyticSimpleActionDispatch } from "~/analytics/Analytics";
import { getChartAxisDateFormatter } from "../../dataTransformation/dateHelpers";
import { getChartReadyInsightsData, getYAxisUnitOfTimeKeys } from "../../dataTransformation/getChartReadyInsightsData";
import { getEvenlySpacedTickArray, getYAxisDataMax } from "../../dataTransformation/getYAxisDataMax";
import { formatDurationInWords } from "../../dataTransformation/stringHelpers";
import { insightsCadenceLookup, insightsCadenceXAxisTickInterval } from "../../insightsCadence";
import { InsightsTooltip } from "../ChartTooltips/InsightsTooltip/InsightsTooltip";
import LineChart from "../Charts/LineChart";
import { DownloadReportCsvButton } from "../DownloadReportCsvButton";
import { InsightsChartCard } from "../InsightsChartCard";
import { LeadTimeTrendTables } from "./TrendTables/LeadTimeTrendTables";
type Props = ReportMetricsPageProps;
export function ReportDeploymentLeadTimeInner({ report, bffResponse, split, cadence, busy }: Props) {
    const dispatchAction = useAnalyticSimpleActionDispatch();
    const chartData = getChartReadyInsightsData(bffResponse.Series);
    const { LeadTimeKey } = getYAxisUnitOfTimeKeys(chartData);
    const maxYAxisValue = getYAxisDataMax(chartData, `LeadTime.mean.${LeadTimeKey}`);
    const currentGranularity = insightsCadenceLookup[cadence].granularity;
    const dateFormatter = getChartAxisDateFormatter(currentGranularity);
    const showSeries = split !== InsightsMetricsSplit.None;
    useEffect(() => {
        dispatchAction("View Insights Report Deployment Lead Time");
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return (<main>
            <section style={{ padding: "1rem" }}>
                <InsightsChartCard height={500}>
                    <LineChart data={chartData} loading={Boolean(busy)} dataKey={`LeadTime.mean.${LeadTimeKey}`} yAxisLabel={`Avg. no. of ${LeadTimeKey.toLowerCase()}`} xAxisDataKey="StartOfInterval" xAxisType="category" yAxisType="number" yAxisDomain={[0, maxYAxisValue]} yAxisTickArray={getEvenlySpacedTickArray(maxYAxisValue)} xTickFormatter={dateFormatter} xAxisTickInterval={insightsCadenceXAxisTickInterval[cadence]} tooltip={<InsightsTooltip showSeries={showSeries} dataKey="LeadTime.mean.duration" valueFormatter={formatDurationInWords} cadence={cadence}/>} showLegend={showSeries}/>
                </InsightsChartCard>
                <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 8 }}>
                    <DownloadReportCsvButton report={report}/>
                </div>
            </section>
            <section>
                <LeadTimeTrendTables trends={bffResponse.LeadTime} report={report}/>
            </section>
        </main>);
}
export function ReportDeploymentLeadTime({ report }: {
    report: InsightsReportResource;
}) {
    return (<ReportMetricsLayout title="Deployment lead time" report={report} trendKey="LeadTime">
            {(props) => <ReportDeploymentLeadTimeInner {...props}/>}
        </ReportMetricsLayout>);
}
